"use client";

import { cn } from "@/lib/utils";
import React from "react";

interface MarqueeProps {
  children: React.ReactNode;
  className?: string;
  pauseOnHover?: boolean;
}

export default function Marquee({ children, className, pauseOnHover }: MarqueeProps) {
  const marqueeContent = React.Children.toArray(children);

  return (
    <div
      className={cn(
        "flex w-full overflow-hidden [--duration:40s] [--gap:2.5rem]",
        className
      )}
    >
      <div
        className={cn(
          "flex min-w-full shrink-0 gap-[2.5rem] py-4 pr-10",
          "animate-[marquee_var(--duration)_linear_infinite]",
          pauseOnHover && "hover:[animation-play-state:paused]"
        )}
      >
        {marqueeContent}
        {marqueeContent}
      </div>
      <div
        className={cn(
          "flex min-w-full shrink-0 gap-[2.5rem] py-4 pr-10",
          "animate-[marquee_var(--duration)_linear_infinite]",
          pauseOnHover && "hover:[animation-play-state:paused]"
        )}
      >
        {marqueeContent}
        {marqueeContent}
      </div>
    </div>
  );
}
